import { Slide } from "@jelly/lesson";
import { task as task03 } from "../../../../../task/course-03/lesson-06/task-03";

const task: Slide = {
  title: `Which fundamental operation is required in every software  implementation of a GA-based simulation model?`,
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
